import { Box } from '@wix/design-system';
import { usePreviousState } from '@wix/rules-panel-ui';
import { useAtom, useAtomValue } from 'jotai';
import React, { useEffect } from 'react';
import { activeTabIdAtom, totalIssuesCountAtom } from '../../../atoms/session-atoms';
import { BiCtaNames } from '../../../bi/types';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../../../consts';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useMultilingualWarning } from '../../../hooks/use-multilingual-warning';
import { A11yWizardDetectedIssuesTab } from '../../../panel/a11y-wizard-detected-issues-tab';
import { A11yWizardManualTasksTab } from '../../../panel/a11y-wizard-manual-tasks-tab';
import { SecondaryLanguageWarning } from '../../../warnings/secondary-language-error';
export const WizardPanelContentResults = _ref => {
  let {
    ruleGroups,
    manualTasks
  } = _ref;
  const [currentTabId, setCurrentTabId] = useAtom(activeTabIdAtom);
  const previousTabId = usePreviousState(currentTabId);
  const biLogger = useBiLogger();
  const totalIssuesCount = useAtomValue(totalIssuesCountAtom);
  const {
    shouldShowSecondaryLanguageWarning
  } = useMultilingualWarning();
  const goToManualTasks = () => {
    setCurrentTabId(ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS);
    biLogger.ctaClick({
      ctaName: BiCtaNames.GoToManualTasks
    });
  };
  const detectedIssuesNumber = totalIssuesCount;
  const manualTasksNumber = manualTasks.length;
  useEffect(() => {
    if (previousTabId !== currentTabId && ruleGroups.length) {
      biLogger.panelView({
        detectedIssuesNumber,
        manualTasksNumber,
        ruleGroups
      });
    }
  });
  return shouldShowSecondaryLanguageWarning ? /*#__PURE__*/React.createElement(Box, {
    align: "center",
    boxSizing: "border-box",
    direction: "vertical",
    gap: "SP1",
    height: "100%",
    minHeight: "600px",
    padding: "SP2 SP4 SP4 SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(SecondaryLanguageWarning, null))) : /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    height: "100%",
    minHeight: "600px"
  }, currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS && /*#__PURE__*/React.createElement(A11yWizardDetectedIssuesTab, {
    goToManualTasks: goToManualTasks,
    issuesNumber: detectedIssuesNumber,
    ruleGroups: ruleGroups
  }), currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS && /*#__PURE__*/React.createElement(A11yWizardManualTasksTab, {
    issuesNumber: manualTasksNumber,
    manualTasks: manualTasks
  }));
};
//# sourceMappingURL=wizard-panel-content-results.js.map